import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _get from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { ElementNode } from "lexical";
/** Converts a `div[data-lexical-layout-item]` into a layout item node. */
function convertLayoutItemElement() {
  return {
    node: $createLayoutItemNode()
  };
}

/** A single column inside a layout container. */
export var LayoutItemNode = /*#__PURE__*/function (_ElementNode) {
  function LayoutItemNode() {
    _classCallCheck(this, LayoutItemNode);
    return _callSuper(this, LayoutItemNode, arguments);
  }
  _inherits(LayoutItemNode, _ElementNode);
  return _createClass(LayoutItemNode, [{
    key: "createDOM",
    value: function createDOM() {
      var dom = document.createElement("div");
      dom.setAttribute("data-lexical-layout-item", "true");
      return dom;
    }
  }, {
    key: "exportDOM",
    value: function exportDOM() {
      var element = document.createElement("div");
      element.setAttribute("data-lexical-layout-item", "true");
      return {
        element: element
      };
    }
  }, {
    key: "updateDOM",
    value: function updateDOM() {
      return false;
    }
  }, {
    key: "exportJSON",
    value: function exportJSON() {
      return _objectSpread(_objectSpread({}, _superPropGet(LayoutItemNode, "exportJSON", this, 3)([])), {}, {
        type: "layout-item",
        version: 1
      });
    }
  }, {
    key: "isShadowRoot",
    value: function isShadowRoot() {
      return true;
    }
  }], [{
    key: "getType",
    value: function getType() {
      return "layout-item";
    }
  }, {
    key: "clone",
    value: function clone(node) {
      return new LayoutItemNode(node.__key);
    }
  }, {
    key: "importJSON",
    value: function importJSON() {
      return $createLayoutItemNode();
    }
  }, {
    key: "importDOM",
    value: function importDOM() {
      return {
        div: function div(domNode) {
          return domNode.hasAttribute("data-lexical-layout-item") ? {
            conversion: convertLayoutItemElement,
            priority: 2
          } : null;
        }
      };
    }
  }]);
}(ElementNode);

/** Creates a layout item node. */
export function $createLayoutItemNode() {
  return new LayoutItemNode();
}

/** Type guard for layout item nodes. */
export function $isLayoutItemNode(node) {
  return node instanceof LayoutItemNode;
}